import SoftButton from "components/SoftButton";
import React, { useState } from "react";
import MDModal from "components/MDModal";
import SoftBox from "components/SoftBox";
import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import { Edit } from "@mui/icons-material";
import {
  Button,
  FormControl,
  Icon,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from "@mui/material";
import { useAddAgencyBalance } from "queries/agency";
import { useUserInfo } from "context/user";
import FormField from "components/FormField";
import SoftInput from "components/SoftInput";
import Multiselect from "./components/Multiselect";
import { useAgencyInfo } from "context/agency";
import {
  useStripe,
  Elements,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import AddCardModal from "components/Subscriptionodal/AddCardModal";

function AddProduct({ open, onClose }) {
  const [agency, Update] = useAgencyInfo();
  const [processing, setProcessing] = useState(false);
  const [stripeErr, setStripeErr] = useState(false);
  const stripe = useStripe();

  // Adding balance also writes a new charge-log row, so a successful add
  // refreshes both the agency doc (Balance field) and billing/index.js's
  // "charge-logs" list.
  const addBalanceMutation = useAddAgencyBalance();

  const handleSubmit = async (e) => {
    // alert(agency.Balance)
    e.preventDefault();
    setProcessing(true);
    // alert(amount)
    const payload = {
      Balance: e.target.amount.value,
      type: "credit",
      agency_id: agency._id,
    };

    var { response } = await addBalanceMutation.mutateAsync({ payload });
    if (response) {
      if (response.PaymentDone) {
        const payload = {
          payment_confirm: "success",
          Balance: e.target.amount.value,
          type: "credit",
          agency_id: agency._id,
          logs_id: response.Balance_logs._id
        };
        const updatedata = await addBalanceMutation.mutateAsync({
          payload,
          toaster: true,
        });
        console.log(updatedata.response, 'updatedata')
        if (updatedata.response.success) {
          Update(updatedata.response.data);
          onClose();
        }
      } else {
        onClose()
      }
    }
  };
  return (
    <>
      {open &&
        <div className="modal-zz-confirm text-left"  >

          <div className="scrollable-modal-content bg-white  rounded" style={{ position: "relative" }}>
            <h2 className='text-black text-left font-14'>Add Balance
            </h2>
            <span className='crossison' onClick={onClose}>X</span>
            <SoftBox>
              <SoftBox component="form" onSubmit={handleSubmit} role="form">
                <SoftBox>
                  <SoftTypography variant="button" sx={{ fontSize: "14px", fontWeight: "500" }} mb={1}>
                    Amount
                  </SoftTypography>
                  <SoftInput label="Amount" placeholder="Amount" name="amount" type="number" fullWidth isRequired />
                  {stripeErr && <small>{stripeErr}</small>}
                </SoftBox>

                <SoftBox display="flex" justifyContent="flex-end">
                  <SoftButton
                    variant="outlined"
                    color="error"
                    type="button"
                    sx={{ mt: 4, mb: 1 }}
                    onClick={onClose}
                  >
                    close
                  </SoftButton>
                  <SoftButton
                    variant="outlined"
                    color="dark"
                    type="submit"
                    sx={{ mt: 4, mb: 1, ml: 1 }}
                    loading={processing}
                    disabled={processing}
                  >
                    Add
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </SoftBox>
          </div>
        </div>}
    </>
  );
}
const CreateModal = ({ agencyStripe, handleRefresh }) => {
  const stripePromise = loadStripe(
    "pk_live_51P8mb1EcX0mI702zZ70Q2pitPvGR1j0HMbeNh2QnN9oCuDTdqqOwtOnFhdan8OYL1OKon2YwATPbzEVMugSRA0ue00Hh1Yw63r"
  );
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [cardModal, setCardModal] = useState(false);

  const handlemodal = () => {
    if (agencyStripe) {
      setOpenAddProduct(true);
    } else {
      setCardModal(true)
    }
  };

  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false);
  };
  return (
    <>
      {/* <SoftButton color="dark" variant="outlined" onClick={handlemodal}>
        Create
      </SoftButton> */}
      <button className="btn btn-outline-dark" onClick={handlemodal}>
        Add Balance
      </button>
      {
        openAddProduct &&
        <Elements stripe={stripePromise}>
          <AddProduct open={openAddProduct} onClose={closeAddProduct} />
        </Elements>
      }
      {
        cardModal &&
        <Elements stripe={stripePromise}>
          <AddCardModal
            open={cardModal}
            onclose={() => setCardModal(false)}
            agencyStripe={agencyStripe}
            handleRefresh={handleRefresh}
          />
        </Elements>
      }
    </>
  );
};

export default CreateModal;
CreateModal.propTypes = {
  handleRefresh: PropTypes.func.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};
